"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStyle = exports.getClassName = exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _excluded = ["dashed", "light", "height", "vertical"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var styles = {
  "muiDivider": "z0uojC",
  "default": "o5jvjD",
  "light": "alCruG",
  "vertical": "v5uCsh",
  "dashed": "pCwQqv"
};
var getClassName = exports.getClassName = function getClassName(_ref) {
  var light = _ref.light,
    vertical = _ref.vertical,
    dashed = _ref.dashed;
  return (0, _clsx["default"])(styles.muiDivider, light ? styles.light : styles["default"], vertical && styles.vertical, dashed && !vertical && styles.dashed);
};
var getStyle = exports.getStyle = function getStyle(_ref2) {
  var vertical = _ref2.vertical,
    height = _ref2.height;
  return (
    // Apply style only when it's used (vertical mode)
    // and if the value is different than the default (100%)
    vertical && height !== '100%' ? {
      '--height': height
    } : {}
  );
};
var MuiDivider = function MuiDivider(_ref3) {
  var dashed = _ref3.dashed,
    light = _ref3.light,
    height = _ref3.height,
    vertical = _ref3.vertical,
    props = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/_react["default"].createElement("hr", _extends({}, props, {
    className: getClassName({
      light: light,
      vertical: vertical,
      dashed: dashed
    }),
    style: getStyle({
      vertical: vertical,
      height: height
    })
  }));
};
MuiDivider.propTypes = process.env.NODE_ENV !== "production" ? {
  dashed: _propTypes["default"].bool,
  height: _propTypes["default"].string,
  light: _propTypes["default"].bool,
  vertical: _propTypes["default"].bool
} : {};
var _default = exports["default"] = MuiDivider;